var styles = {
  "Card": "Online-Store-UI-Card_1nihz",
  "topShadow": "Online-Store-UI-Card--topShadow_1djdk",
  "bottomShadow": "Online-Store-UI-Card--bottomShadow_5mbfk"
};

export { styles as default };
